import { get } from '../axios'
import { customerDashboard, customerOverview, PeriodQuery, platformOverview, spend } from './dashboard'

function periodParams({ start, end }: PeriodQuery) {
    return new URLSearchParams({ start: start ?? '', end: end ?? '' }).toString()
}

export function fetchAdminOverview(query: PeriodQuery) {
    return get(platformOverview, `/admin/dashboard/overview?${periodParams(query)}`)
}

export function fetchAdminCustomers(query: PeriodQuery) {
    return get(customerOverview, `/admin/dashboard/customers?${periodParams(query)}`)
}

export function fetchAdminSpend(query: PeriodQuery) {
    return get(spend, `/admin/dashboard/spend?${periodParams(query)}`)
}

export function fetchCustomerDashboard() {
    return get(customerDashboard, '/dashboard')
}
